import constants from './constants';
import { trackPromise } from 'react-promise-tracker';
import { getEnrollmentsService } from '../../services/planDetailsService';

const { SET_ENROLLMENTS_BEGIN, SET_ENROLLMENTS_SUCCESS, SET_DEFAULT_DEMOGRAPHIC_FIELD,SET_ENROLLMENTS_ERROR, SET_ENROLLMENTS_CLEANUP , UPDATE_DEMOGRAPHIC_FIELD} = constants;

export const setEnrollmentsBegin = () => ({
    type: SET_ENROLLMENTS_BEGIN
});

export const setEnrollmentsSuccess = data => ({
    type: SET_ENROLLMENTS_SUCCESS,
    payload: { data }
});

export const setEnrollmentsError = error => ({
    type: SET_ENROLLMENTS_ERROR,
    payload: { error }
});
export const updateDemographicField = (name , value)=> ({
    type: UPDATE_DEMOGRAPHIC_FIELD,
    payload: {name , value}
});

export const setEnrollmentsClean = () => ({
    type: SET_ENROLLMENTS_CLEANUP
});
export const setDefaultUpdateDemographic = (data)=> ({
    type: SET_DEFAULT_DEMOGRAPHIC_FIELD,
    payload: data
});
export const getEnrollments = (tenantId,memberAccountHeader) => {
    return (dispatch) => {
        dispatch(setEnrollmentsBegin());
        trackPromise(
            getEnrollmentsService(tenantId,memberAccountHeader)
                .then(res => dispatch(setEnrollmentsSuccess(res.data)))
                .catch(err => dispatch(setEnrollmentsError(err)))
        );
    };
};
